/** Equipos: plan, asientos, miembros, dueño y uso de los últimos 30 días. */
import { Link } from 'react-router'
import { useApp } from '../../components/AppContext'
import { ErrorBox, Skeleton } from '../../components/ui'
import { compacto } from '../../lib/adminFormat'
import { formatDate } from '../../lib/format'
import { useAsync, useDocumentTitle } from '../../lib/hooks'
import { PLAN_LABEL } from './common'

export function Equipos() {
  useDocumentTitle('Equipos · Administración')
  const { api } = useApp()
  const e = useAsync(() => api.adminEquipos(), [api])
  if (e.error) return <ErrorBox error={e.error} onRetry={() => void e.reload()} />
  if (!e.data) return <Skeleton h={200} />
  if (!e.data.items.length)
    return (
      <div className="empty">
        <h2>Todavía no hay equipos</h2>
        <p className="muted">Cuando alguien cree un equipo aparecerá aquí.</p>
      </div>
    )
  return (
    <div className="card tight" style={{ overflowX: 'auto' }}>
      <table className="simple">
        <caption className="sr">Equipos de eco</caption>
        <thead>
          <tr>
            <th scope="col">Equipo</th>
            <th scope="col">Dueño</th>
            <th scope="col">Plan</th>
            <th scope="col" className="num">
              Personas
            </th>
            <th scope="col" className="num">
              Asientos
            </th>
            <th scope="col" className="num">
              Reuniones (30 días)
            </th>
            <th scope="col" className="num">
              Horas (30 días)
            </th>
            <th scope="col">Creado</th>
          </tr>
        </thead>
        <tbody>
          {e.data.items.map((t) => (
            <tr key={t.orgId}>
              <td style={{ fontWeight: 550 }}>{t.nombre}</td>
              <td>
                {t.duenoEmail ? (
                  <Link
                    className="link"
                    to={`/admin/usuarios?q=${encodeURIComponent(t.duenoEmail)}`}
                  >
                    {t.duenoEmail}
                  </Link>
                ) : (
                  '—'
                )}
              </td>
              <td>
                {PLAN_LABEL[t.plan]}
                {t.proveedor === 'manual' && <span className="faint"> · cortesía</span>}
                {t.proveedor === 'paddle' && t.estado !== 'active' && (
                  <span className="faint"> · {t.estado}</span>
                )}
              </td>
              <td className="num">{t.miembros}</td>
              <td className="num">{t.asientos}</td>
              <td className="num">{t.reuniones30}</td>
              <td className="num">{compacto(Math.round((t.minutos30 / 60) * 10) / 10)}</td>
              <td>{formatDate(t.creadoEn)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
